<template>
  <div class="ginojisshusei-Quetions">
   <h2>よくある質問</h2>

     <UiLine />

     <GinojisshuseiQuestionsQuestion sentence="失踪する実習生に対して対策してますか？" sentence2="入管庁によると、失踪は年々増加しており、2018年は前年比1963人増の9052人。19年上半期も4499人で、前年同期を256人上回っています。当組合では失踪の大きな原因である「多額の借金」を実習生にさせることなく、日本で実習業務に専念できる環境作りを送出し機関と共に行っております。実習実施者様につきましては、技能実習生受け入れ前に何度も打ち合わせをさせていただき、賃金トラブルが無いよう努めています。技能実習生の人権侵害の観点から実習実施者様の指導方法につきましてもアドバイスさせていただきます。実習生が失踪しない仕組み（コミュニティ）作りも合わせて行っておりますのでご安心ください。"/>
     <GinojisshuseiQuestionsQuestion sentence="入国までの期間はどのくらい？" sentence2="企業さまの求人ご依頼から配属までは約8～9カ月を有します。面接会からは約6～7カ月を見込んでいただいております。面接合格後に必要書類作成、在留資格認定申請の手続きに移行します。実習生は日本入国までの約4カ月の間、協定を締結している送出し機関で日本語指導、日本でのマナー、礼儀、文化、専門技能指導を学びます。企業様の要望もいただきながら配属時点でレベルの高い人材へと育成して参ります。 "/>
     <GinojisshuseiQuestionsQuestion sentence="派遣社員と技能実習生の違いは？" sentence2="外国人の派遣社員を受け入る場合は、直接の雇用関係が人材派遣会社（派遣元）との間にあるため、在留資格の申請をはじめ、手間や専門知識は必要ないといえますが、知らず知らずに不法就労者や就労できない在留資格を所持している人材を受け入れてしまうケースもゼロとはいえません。万が一の場合、派遣会社はもちろんですが、受入れ企業にも責任が問われる可能性があります。技能実習生の場合は実習実施者様が直接雇用することになりますし、技能実習法（外国人の技能実習の適正な実施及び技能実習生の保護に関する法律）のもとで制度の利用を行いますので、在留管理につきましても監理団体である私どもがサポートさせていただきます。"/>

     <UiDetailButton :path="`/`" link="トップページに戻る"/>
  </div>
</template>

<script>
import UiLine from "@/components/Ui/Line.vue";
import GinojisshuseiQuestionsQuestion from "@/components/Ginojisshusei/Questions/Question.vue";
import UiDetailButton from "@/components/Ui/DetailButton.vue";
export default {
  name: "GinojisshuseiQuestions",
  components: {
    UiLine,
    GinojisshuseiQuestionsQuestion,
    UiDetailButton,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    rootUrl() {
      return this.$store.getters.rootUrl;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>



</style>